import throttle from "lodash.throttle"
import debounce from "lodash.debounce"

function init() {

	window.addEventListener('resize', debounce( initTriggers, 300 ))
	window.addEventListener('load', initTriggers)
}

function initTriggers() {

	let offset = 0

	// If mobile fixed header showing, get it's height to use as offset
	if (window.innerWidth < 1250) {
		const nav = document.getElementById('site-header-nav')

		if (nav !== null) {
			offset = nav.offsetHeight
		}
	}

	// Check if subnav exists on page
	const subnav = document.querySelector('[data-subnav]')

	// If found
	if (subnav !== null) {

		const faqs        = document.querySelectorAll('[data-faqs]') // Get all FAQs blocks on page
		const subnavItems = document.querySelectorAll('[data-subnav-item]') // Get all subnav items
		const viewportH   = window.innerHeight // Get viewport height

		// Smooth scroll to FAQs when subnav items clicked
		for (const item of subnavItems) {

			item.addEventListener('click', (e) => {
				e.preventDefault()

				const target = document.getElementById( item.getAttribute('data-subnav-item') )

				if (target !== null) {
					const scrollingTo = target.getBoundingClientRect().top - offset

					window.scrollTo({
						top: scrollingTo,
						behavior: 'smooth'
					})
				}
			})
		}

		// Add scroll event listener
		window.addEventListener('scroll', throttle( (e) => {

			// Loop through FAQs blocks
			for (const el of faqs) {

				// Get bounding rect of element
				const offset = el.getBoundingClientRect()

				// If element is less than or equal to 10% from top of viewport
				if ( ((offset.top/viewportH) * 100) <= 10 ) {

					const id         = el.id // Get id of FAQs block
					const subnavItem = document.querySelector('[data-subnav-item="' + id + '"]') // Get matching subnav item

					// If subnav item found
					if (subnavItem !== null) {

						// Loop through all subnav items and remove 'active' class
						for (const item of subnavItems) {
							item.classList.remove('active')
						}

						// Add 'active' class to matching subnav item
						subnavItem.classList.add('active')
					}
				}
			}
		}, 200))
	}
}

export default init